// Page: Virtual Advisor Q&A Pairs Management

import React, { useState } from 'react';
import { Tabs } from 'antd';
import { BarChartOutlined, DatabaseOutlined } from '@ant-design/icons';
import QAPairStatistics from './QAPairStatistics';
import QAPairList from './QAPairList';
import AnalyticsDashboard from './AnalyticsDashboard';

const { TabPane } = Tabs;

const QAPairManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState('management');

  return (
    <div style={{ padding: '24px' }}>
      <Tabs activeKey={activeTab} onChange={setActiveTab} size="large">
        <TabPane
          tab={
            <span>
              <DatabaseOutlined />
              Quản lý Q&A Pairs
            </span>
          }
          key="management"
        >
          <QAPairStatistics />
          <div style={{ marginTop: 24 }}>
            <QAPairList />
          </div>
        </TabPane>

        <TabPane
          tab={
            <span>
              <BarChartOutlined />
              Analytics Dashboard
            </span>
          }
          key="analytics"
        >
          <AnalyticsDashboard />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default QAPairManagement;
